




























































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import PointsParticuliers from '@/components/SeismicInsepctionForm/_PointsParticuliers.vue'

export default Vue.extend({
  name: 'SimpleTrunk32',
  components: {
    PointsParticuliers
  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  watch: {
    form () {
      console.log('Trunk 3 2 watch', '---')
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis3.axialLockNearElbow)
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis3.oneLockEvery3Supports)
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis3.postSeismicREXisApplied)
      this.$forceUpdate()
    }
  },
  created () {
    console.log('SIMPLE TRUNK 32', JSON.parse(JSON.stringify(this.form.analysis.simpleTrunkAnalysis3)))
  },
  mounted () {
    this.$forceUpdate()
  },
  data () {
    return {
      specificPoints: [] as Array<string>
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },
  methods: {

  }
})

